// Hexes do design system usados pelos mapas de cor de STATUS do consolidador.
//
// Vive aqui, e não em `constants/Color.js`, porque o `Color.js` tem 20
// importadores e os três consumidores destes tokens são locais
// (`anbima-risco-color.js`, `anbima-status-grafico.js`,
// `alocacao-estrategica-status.js`). Encostar no arquivo compartilhado por
// causa deles arrasta o grafo de `--findRelatedTests` do CI para a base
// inteira — medido em 2026-08-25: 135 suítes viraram 2261.
//
// `DS_TOKEN_HEX` traduz o nome de prop que o `BaseStatus` resolve
// (`_base-status.vue:formatColor`) para o hex do mesmo token, porque Chart.js
// pinta em canvas e não entende `var(--danger)`.
//
// `CINZA_SEM_INFORMACAO` é ausência de CONFIGURAÇÃO (sem teto cadastrado, sem
// perfil) e `CINZA_SEM_DADO` é ausência de DADO (o backend não mandou o
// status) — o segundo é mais claro de propósito. Hex e não `var(--secondary)`:
// o `:root` gera `--secondary` a partir de `$gray-4` (`#C7BBC9`), claro demais
// para texto de chip.

export const CINZA_SEM_INFORMACAO = '#8E8E8E'

export const CINZA_SEM_DADO = '#C7BBC9'

export const DS_TOKEN_HEX = Object.freeze({
  danger: '#EB5757',
  'warning-new': '#FF990A',
  success: '#398E4A',
})
